module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/admin-page/admin-page.component.scss
// module id = ./src/app/admin/components/admin-page/admin-page.component.scss
// module chunks = main